import React, { useState, useEffect } from "react";
import { useNavigate, useSearchParams, Link } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { toast } from "sonner";
import { Mail, Lock, User, ArrowRight } from "lucide-react";

export default function AuthPage() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const { user, login, register } = useAuth();
  const [mode, setMode] = useState(params.get("mode") === "register" ? "register" : "login");
  const [form, setForm] = useState({ name: "", email: "", password: "" });
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (user) navigate(user.role === "admin" ? "/admin" : "/dashboard");
  }, [user, navigate]);

  const submit = async (e) => {
    e.preventDefault();
    if (loading) return;
    setLoading(true);
    let res;
    if (mode === "register") {
      if (!form.name || !form.email || !form.password) { setLoading(false); return toast.error("Заполните все поля"); }
      res = await register(form.name, form.email, form.password);
    } else {
      res = await login(form.email, form.password);
    }
    setLoading(false);
    if (!res.ok) return toast.error(res.error);
    toast.success(mode === "register" ? "Аккаунт создан!" : "С возвращением!");
    navigate(res.user.role === "admin" ? "/admin" : "/dashboard");
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-5 pt-24 pb-16 relative overflow-hidden">
      <div className="absolute top-10 left-10 h-80 w-80 rounded-full bg-[#ff3798]/25 blob" />
      <div className="absolute bottom-0 right-0 h-72 w-72 rounded-full bg-[#d6ff71]/15 blob" style={{ animationDelay: "2s" }} />

      <div className="relative z-10 w-full max-w-md animate-fade-up">
        <div className="rounded-3xl bg-white/[0.04] border border-white/10 backdrop-blur-xl p-8 shadow-2xl">
          <div className="text-center">
            <div className="mb-3 font-script text-2xl"><span className="text-[#ff3798]">Hair</span><span className="text-white">Mama</span></div>
            <h1 className="text-3xl font-extrabold">{mode === "register" ? "Создать аккаунт" : "Вход в кабинет"}</h1>
            <p className="text-white/50 mt-2 text-sm">{mode === "register" ? "Присоединяйтесь к школе HairMama" : "Рады видеть вас снова"}</p>
          </div>

          <form onSubmit={submit} className="mt-7 space-y-4">
            {mode === "register" && (
              <Field icon={User} placeholder="Ваше имя" value={form.name} onChange={(v) => setForm({ ...form, name: v })} />
            )}
            <Field icon={Mail} type="email" placeholder="Email" value={form.email} onChange={(v) => setForm({ ...form, email: v })} />
            <Field icon={Lock} type="password" placeholder="Пароль" value={form.password} onChange={(v) => setForm({ ...form, password: v })} />

            <button type="submit" disabled={loading} className="w-full rounded-xl bg-[#ff3798] py-3.5 font-semibold hover:bg-[#ff5aac] transition-colors flex items-center justify-center gap-2 disabled:opacity-60 shadow-[0_10px_28px_-10px_rgba(255,55,152,0.9)]">
              {loading ? "Подождите..." : (mode === "register" ? "Зарегистрироваться" : "Войти")}
              {!loading && <ArrowRight size={18} />}
            </button>
          </form>

          <div className="mt-6 text-center text-sm text-white/50">
            {mode === "register" ? "Уже есть аккаунт?" : "Нет аккаунта?"}{" "}
            <button type="button" onClick={() => setMode(mode === "register" ? "login" : "register")} className="text-[#d6ff71] font-semibold hover:underline">
              {mode === "register" ? "Войти" : "Зарегистрироваться"}
            </button>
          </div>

          <div className="mt-6 rounded-xl bg-white/[0.03] border border-white/10 p-3 text-xs text-white/40 text-center">
            Демо-доступ — админ: <span className="text-[#d6ff71]">admin@hairmama.ua</span> / admin123
          </div>
        </div>
        <Link to="/" className="block text-center mt-5 text-sm text-white/40 hover:text-white transition-colors">← На главную</Link>
      </div>
    </div>
  );
}

function Field({ icon: Icon, type = "text", placeholder, value, onChange }) {
  return (
    <div className="relative">
      <Icon size={18} className="absolute left-4 top-1/2 -translate-y-1/2 text-white/40" />
      <input type={type} placeholder={placeholder} value={value} onChange={(e) => onChange(e.target.value)}
        className="w-full rounded-xl bg-black/40 border border-white/10 pl-11 pr-4 py-3.5 text-white placeholder:text-white/30 outline-none focus:border-[#ff3798] focus:ring-2 focus:ring-[#ff3798]/30 transition-all" />
    </div>
  );
}
